<template>
  <div>
    <h1>Matters</h1>
    <v-text-field label="Reference" v-model="reference" outline />
    <v-select
      :items="offices"
      v-model="office"
      label="Office"
      item-text="value"
      item-value="id"
      outline
    />
    <v-data-table
      :headers="headers"
      :items="matters"
      :pagination.sync="pagination"
      :total-items="totalMatters"
      :footer-props="footerProps"
      :loading="loading"
      class="elevation-1"
      dense
    >
      <template v-slot:items="props">
        <tr @click="navigate(props.item)">
          <td>{{ props.item.Open_Date | formatDate }}</td>
          <td>{{ props.item.Reference }}</td>
          <td>{{ props.item.Description }}</td>
          <td>{{ props.item.Status_UID }}</td>
          <td>
            {{ props.item.contactname ? props.item.contactname.Full : null }}
          </td>
          <td>
            {{ props.item.feeearner ? props.item.feeearner.Reference : null }}
          </td>
          <td>
            {{ props.item.mattertype ? props.item.mattertype.Reference : null }}
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import ca from "@/api/ca";
export default {
  name: "Matters",
  metaInfo: {
    title: "Matters",
    titleTemplate: "%s - Conveyancing accounts",
    htmlAttrs: {
      lang: "en",
      amp: true
    }
  },
  data() {
    return {
      matters: [],
      loading: true,
      footerProps: {
        "items-per-page-options": [10, 20, 30, 40, 50]
      },
      totalMatters: 0,
      headers: [
        { text: "Open_Date", value: "Open_Date" },
        { text: "Reference", value: "Reference" },
        { text: "Description", value: "Description" },
        { text: "Status_UID", value: "Status_UID" },
        // { text: "Client", value: "client" },
        { text: "Contactname", value: "contactname.Full" },
        // { text: "Costcentre", value: "costcentre.Name" },
        { text: "Feeearner", value: "feeearner.Reference" },
        { text: "Mattertype", value: "mattertype.Reference" }
        // { text: "Partner", value: "partner.Reference" }
      ],
      reference: null,
      timerId: null,
      offices: [
        { id: "q1", value: "Chelmsford" },
        { id: "q5", value: "Cambridge" }
      ],
      office: "q1",
      pagination: {
        page: 1,
        rowsPerPage: 20,
        sortBy: "Open_Date",
        descending: true
      }
    };
  },
  methods: {
    async fetchMatters() {
      const { page, sortBy, descending, rowsPerPage } = this.pagination;
      const limit = rowsPerPage;
      const skip = (page - 1) * rowsPerPage;
      let sortByX;
      if (sortBy && sortBy != "") {
        sortByX = sortBy;
        if (descending != undefined) {
          sortByX += `:${descending == true ? "desc" : "asc"}`;
        }
        // console.log(sortByX);
      }
      const response = await ca.get(`/${this.office}/matters`, {
        params: {
          limit,
          skip,
          sortBy: sortByX,
          reference: this.reference
        }
      });
      // console.log(response.data);
      this.matters = response.data;
      this.loading = false;
    },
    async fetchMattersCount() {
      const response = await ca.get(`/${this.office}/matters/count`);
      // console.log(response.data);
      this.totalMatters = response.data;
    },
    navigate(item) {
      this.$router.push({
        name: "ledger",
        params: { office: this.office, id: item._id }
      });
    },
    search() {
      // debounce
      clearTimeout(this.timerId);
      this.timerId = setTimeout(() => {
        this.fetchMatters();
      }, 500);
    },
    update() {
      this.fetchMatters();
      this.fetchMattersCount();
    }
  },
  watch: {
    pagination: {
      handler() {
        this.fetchMatters();
      },
      deep: true
    },
    reference: {
      handler() {
        this.search();
      }
    },
    office: {
      handler() {
        this.update();
      }
    }
  },
  created() {
    this.update();
  }
};
</script>